import { useMemo } from "react";
import ViewSheet from "../components/ViewSheet";
import { useVisible } from "utils/hooks/useVisible";

interface UseViewSheetProps {
    approve: (request: any) => void;
    deny: (request: any) => void;
}

export const useViewSheet = ({ approve, deny }: UseViewSheetProps) => {
    const { open, close, visible, selected } = useVisible();
    const sheet = useMemo(() => {
        return (
            <ViewSheet
                selected={selected}
                visible={visible}
                close={close}
                approve={approve}
                deny={deny}
            />
        );
    }, [approve, close, deny, selected, visible]);

    return { open, sheet };
};
